<template>
  <v-container pa-0 grid-list-md text-xs-center>
    <v-layout row justify-center>
      <v-flex xs8>
        <v-card>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-card-title primary-title>
              <div>
                <div class="headline">Control de Conciliaciones</div>
                <span class="grey--text">Archivo EXCEL de Conciliaciones</span>
              </div>
            </v-card-title>

            <v-card-text  class="mb-5 elevation-0" height="200px">
              <v-layout justify-center>

                <v-flex xs12 sm6 md6 align-center justify-center v-if="filterRole(['administrador'])">
                  <v-autocomplete
                      :filter="customFilter"
                      v-model="form.user_id"
                      :items="users"
                      chips
                      color="blue-grey lighten-2"
                      label="Seleccione un usuario"
                      item-text="name"
                      item-value="id"
                      autofocus
                  >
                      <template v-slot:item="data">
                          <v-list-tile-content>
                              <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                          </v-list-tile-content>
                      </template>
                  </v-autocomplete>
                </v-flex>

                  <v-flex xs12 sm6 md4 lg3 align-center justify-center>
                    <v-menu
                      ref="menu2"
                      v-model="menu2"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="desde"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="desde"
                          label="Fecha Desde"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                          :rules="[(v) => !!v || 'Fecha desde es requerido']"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        :max="new Date().toISOString().substr(0, 10)"
                        v-model="desde"
                        no-title
                        scrollable
                        color="primary"
                      >
                        <v-spacer></v-spacer>
                        <v-btn flat color="primary" @click="menu2 = false">Cancel</v-btn>
                        <v-btn flat color="primary" @click="$refs.menu2.save(desde)">OK</v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 sm6 md4 lg3 align-center justify-center>
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="hasta"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="hasta"
                          label="Fecha Hasta"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                          :rules="[(v) => !!v || 'Fecha hasta es requerido']"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        :max="new Date().toISOString().substr(0, 10)"
                        v-model="hasta"
                        no-title
                        scrollable
                        color="primary"
                      >
                        <v-spacer></v-spacer>
                        <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                        <v-btn flat color="primary" @click="$refs.menu.save(hasta)">OK</v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
              </v-layout>
            </v-card-text>

            <v-card-actions>
              <v-btn flat :loading="loading" color="purple" @click="submitForm">Descargar</v-btn >
            </v-card-actions>
          </v-form>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog v-model="loading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Porfavor Espere...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import moment from "moment";
moment.locale("es");
import Form from "vform";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  name: "view-conciliacion-file",

  data: () => ({
    users: [{ id:0, name: "TODOS" }],
    menu: false,
    menu2: false,
    modal: false,
    valid: false,
    dialog: false,
    loading: false,
    hasta: new Date().toISOString().substr(0, 10),
    desde: null,
    form: new Form({
      user_id: 0
    }),
  }),

  computed: {
    ...mapGetters({
      user: "authUser",
    }),
  },

  mounted() {
    this.$store.dispatch("fetchUser");
    if (this.filterRole(['administrador'])) {
      this.getUsers();
    }else {
      this.users = [{ id: this.user.id, name: this.user.name }]
      this.form.user_id = this.user.id
    }
  },

  methods: {

    async getUsers() {
       await axios.get(`/api/administracion/contabilidad/get-users-administrativos`)
              .then(res => {
                res.data.forEach(user => {
                  this.users.push(user);
                });
                console.log(this.users, 'users')
              })
              .catch(e => {
                  console.log(e.response)
              })
              .finally(() => this.loading = false)
    },

    filterRole(role) {
      let exists = false
      exists = this.user.roles.filter(rol => {
        for (let index = 0; index < role.length; index++) {
          if(rol.slug === role[index]){
            return rol
          }
        }
      }).length != 0 ? true : false

      return exists
    },

    async submitForm() {
      // console.log(this.form.user_id,"paso")
      if (this.$refs.form.validate()) {
        // console.log("paso")
        this.loading = true;
        await axios({
          url: `/api/admin/backup/control-conciliacion`,
          method: "POST",
          responseType: "blob", // important
          params: {
            user_id: this.form.user_id,
            fecha_desde: this.desde,
            fecha_hasta: this.hasta,
          },
        })
          .then((response) => {
            const blob = new Blob([response.data], {
              type: response.data.type,
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            const contentDisposition = response.headers["content-disposition"];
            const fecha_now = new Date().toISOString().substr(0, 10);
            let fileName = `conciliaciones_${fecha_now}.xlsx`;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
          })
          .catch((error) => {
            this.$store.dispatch("responseMessage", {
              type: "error",
              text: "Error, intente mas tarde",
            });
          })
          .finally(() => (this.loading = false));
      }
    },

    customFilter (item, queryText, itemText) {
        const textOne = item.name.toLowerCase()
        const textTwo = item.name.toLowerCase()
        const searchText = queryText.toLowerCase()
        return textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
    }

  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/colegio_files/ControlConciliacionFile.vue